import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { CHART_LEGEND_LABELS } from "./constants";

export const Legend: FC = () => {
  const { t } = useTranslation("performance-graphs");

  return (
    <div className={classNames("space-y-1", "xxl:space-y-2.5")}>
      {CHART_LEGEND_LABELS.map((label) => (
        <div
          key={label.i18nKey}
          className={classNames("flex items-center gap-4")}
        >
          <div
            className={classNames(
              "h-3 w-3 shrink-0 rounded-full",
              label.className,
            )}
          />
          <div
            className={classNames(
              "text-extra-small text-base-400",
              "xxl:text-regular",
            )}
          >
            {t(`performanceGraphLegend.${label.i18nKey}`, {
              keySeparator: ".",
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
